import { useEffect } from "react";
import { SITE } from "@/config/site";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, path = "", image, type = "website", jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | STJ Innovations` : "STJ Innovations | Clean Spaces | Better Tomorrow";
    const desc = description || "STJ Innovations LLP (brand: STJ Innovations) — Clean Spaces | Better Tomorrow. Pharmaceutical cleanroom equipment and precision engineering solutions, designed and manufactured in New Delhi, India for global markets.";
    const url = `${SITE.url}${path}`;
    const ogImage = image || `${SITE.url}/stj-logo-og.jpg`;
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", SITE.brand);
    setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", ogImage);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path, image, type]);

  if (!jsonLd) return null;
  const scripts = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
  return (
    <>
      {scripts.map((obj, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(obj) }} />
      ))}
    </>
  );
}

export const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.legalName,
  alternateName: SITE.brand,
  slogan: SITE.tagline,
  url: SITE.url,
  logo: `${SITE.url}/stj-logo-og.jpg`,
  description: "STJ Innovations LLP (brand: STJ Innovations) is a New Delhi, India based manufacturer of pharmaceutical cleanroom equipment, controlled-environment solutions, cleanroom furniture and precision SS 304 sheet-metal products, serving pharmaceutical, healthcare, laboratory and other controlled-environment applications in domestic and international markets.",
  email: "connect@stjinnovations.com",
  telephone: ["+91-9560040097", "+91-9810080037", "+91-9811612595"],
  contactPoint: [{
    "@type": "ContactPoint",
    contactType: "sales",
    email: "connect@stjinnovations.com",
    telephone: "+91-9560040097",
    availableLanguage: ["English", "Hindi"],
  }],
  sameAs: ["https://www.linkedin.com/company/stjinnovations/", "https://wa.me/919560040097"],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Plot No. 543/1, Mundka",
    addressLocality: "New Delhi",
    postalCode: "110041",
    addressCountry: "IN",
  },
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.brand,
  url: SITE.url,
};
